import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=32487a25&class=true"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__